/*
 * @fileOverView Form component definition
 */

import Vue from 'vue';
import FacebookSDK from 'mixins/facebookSDK.mixin.js';
import Form from 'components/foundation/forms/form/form.mixin';
import Analytics from 'mixins/analytics.mixin';
import signupConfirmation from './singup-confirmation';

/**
 * [Form Vue]
 * @type {class}
 */
Vue.component('newsletter-vue', {
  mixins: [
    Analytics,
    FacebookSDK,
    Form
  ],
  props: {
    'activeStep': Number,
    'isModalExpanded': false,
    'modalTriggerSource': '',
    'subscriptionType': ''
  },

  data: function() {
    return {
      'connectionIndex': null
    }
  },

  watch: {
    /**
     * Reinitializes analytics every time the parent modal is opened.
     *
     * Multiple sources (popup, header, footer) can trigger the same modal.
     */
    isModalExpanded: function (newValue, oldValue) {
      if (!oldValue && newValue) {
        this.initFormAnalytics();
      }
      else {
        this.destroyFormAnalytics();
      }
    }
  },

  methods: {
    /**
     * Tracks the condition index so other fields can be shown/hidden per value.
     *
     * @method dropdownChanged
     * @param {Number} selectedIndex - The index of the selected dropdown option.
     * @public
     */
    dropdownChanged(selectedIndex) {
      this.connectionIndex = selectedIndex;
    },

    /**
     * Initializes jQuery validation on form submission.
     *
     * Overridden for tweaked ignore rules.
     */
    initializeValidator() {
      this.validator = this.form.validate({
        errorClass: 'js-error',
        ignore: '.js-validation-exempt input, .js-validation-exempt textarea',
        highlight: this.validatorHighlight,
        unhighlight: this.validatorUnhighlight,
        submitHandler: this.handleValidSubmission,
        invalidHandler: this.handleInvalidSubmission
      });
    },

    /**
     * Initializes the variables and event listeners for the form analytics.
     *
     * Needs to be called multiple times as props are updated depending on use.
     */
    initFormAnalytics() {
      this.setFormAnalyticsData({
        "formType": "Email Signup",
        "formName": `email signup: ${this.modalTriggerSource}`,
        "formStep": this.activeStep
      });
      this.setSubscriptionAnalyticsData({
        "subscriptionType": this.subscriptionType,
        "subscriptionLocation": "email signup form"
      });
      this.pushFormViewedEvent();
      this.$nextTick(() => {
        this.attachFormStartedEvent(this.$refs.form, this.pushEmailSubscriptionStartedEvent);
        this.attachFormStartedEvent(this.$refs.form, this.pushFormStartedEvent);
      });
    },

    /**
     * Removes event listeners for the form analytics.
     */
    destroyFormAnalytics() {
      this.$nextTick(() => {
        this.detachFormStartedEvent(this.$refs.form, this.pushEmailSubscriptionStartedEvent);
        this.detachFormStartedEvent(this.$refs.form, this.pushFormStartedEvent);
      });
    },

    /**
     * Shows a confirmation message after the final step is done.
     */
    showConfirmationMessage(reset, web_form_name) {
      if (reset && web_form_name.startsWith('email signup:')) {
        const confirmation = new Vue({
          template: '<signup-confirmation></signup-confirmation>'
        });

        const wrapper = document.createElement('div');
        document.querySelector('#app').appendChild(wrapper);
        confirmation.$mount(wrapper);
      }
    },

    /**
     * Handles form submission. Submits to Scribe and switches between steps.
     *
     * @param {object} form
     *   The form object
     */
    submit(form) {
      if (this.isLoading) return;
      this.isLoading = true;
      this.populateHiddenFormFields(form);

      const $form = $(form);
      const formObject = $form.serializeArray().reduce(function(m,o){ m[o.name] = o.value; return m;}, {});
      const data = JSON.stringify(formObject);
      const reset = this.activeStep === 2;

      $.ajaxSetup({
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        url: 'https://nkcj5mfz93.execute-api.us-east-2.amazonaws.com/prod/'
      });
      $.ajax({data: data}).always(response => {
        // Update the button's state.
        this.isLoading = false;

        // Let the parent modal know this step was successfully submitted.
        this.$emit('step:success', reset);

        this.pushEmailSubscriptionCompletedEvent();
        this.pushFormSubmissionSucceededEvent();
        this.showConfirmationMessage(reset, formObject.web_form_name);

        if (!reset) {
          this.$nextTick(() => {
            this.initFormAnalytics();
          });
        }
      });
    }
  }
});
